export default __webpack_public_path__ + "static/media/photo-1463453091185-61582044d556.3619e52a.jpeg";